var _style, _polygon, _polygon2, _polygon3, _polygon4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.2 58.8",
    style: {
      enableBackground: "new 0 0 71.2 58.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9F9FA;}\n\t.st1{opacity:0.7;fill:#F4F4F4;enable-background:new    ;}\n\t.st2{opacity:0.6;fill:#E5E5E5;enable-background:new    ;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.4,58.8 43.5,15.5 50.3,35.1 39.3,35.1 39.3,46.8 54.2,46.8 58.6,58.8 71.2,58.8 49.3,0 37.1,0  15.9,58.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.4,58.8 43.5,15.5 50.3,35.1 39.3,35.1 39.3,46.8 54.2,46.8 58.6,58.8 71.2,58.8 49.3,0 37.1,0  15.9,58.8 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.4,58.8 43.5,15.5 50.3,35.1 39.3,35.1 39.3,46.8 54.2,46.8 58.6,58.8 71.2,58.8 49.3,0 37.1,0  15.9,58.8 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "33.4,0 21.2,0 0,58.8 11.6,58.8 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconWhite);
export default __webpack_public_path__ + "static/media/logo-icon-white.a0e5ee7e11d4acda773e9ae166dae88c.svg";
export { ForwardRef as ReactComponent };